import { IPartnerAppSettings } from '../interface/IPartnerAppSettings';

export const dev: IPartnerAppSettings  = {
  // cdnBaseUrl: 'http://localhost:5003',
  // cdnBaseUrl: 'https://powerapps-ux-prod-g8ddgzdqa9dhfecf.b01.azurefd.net',
  cdnBaseUrl: 'https://powerapps-ux-acd5bbhtcffkeces.b01.azurefd.net',
  serviceEndPoints: [
    {
      clientId: '',
      serviceEndPoint: '',
    },
  ],
};
